import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BannerData } from '../../services/banner.service'; // Importa la interfaz BannerData
import { faStar, faCheck,faHeartBroken } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-success-banner',
  templateUrl: './success-banner.component.html',
  styleUrls: ['./success-banner.component.scss']
})
export class SuccessBannerComponent implements OnChanges {
  @Input() bannerData: BannerData | null = null;
  message: string = '';
  type: string = '';
  faCheck = faCheck;
  faHeartBroken = faHeartBroken; // Nuevo ícono para dislike
  visible: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bannerData']) {
      if (this.bannerData) {
        this.message = this.bannerData.message;
        this.type = this.bannerData.type;
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  }
}